/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';

import * as action from '../actions';
import * as c from '../constants';

import ActionItemButtonGroup from './ActionItemButtonGroup';

const TransactionHistoryTable = ({
  walletTransaction,
  mobileNumber,
  setFormData,
  formData,
  transId,
  onClear,
  // viewWalletLogs
}) => {
  const [walletHistoryData, setWalletHistoryData] = useState([]);

  // check if the the value is an empty string or null
  const isEmptyChecker = data => (data === '' ? '--' : data);

  useEffect(() => {
    setWalletHistoryData(walletTransaction);
    // viewWalletLogs((res) => {
    //   const status = _.get(res.data.attributes, 'status')
    //   console.log('status:', status)
    // });
  }, [setWalletHistoryData]);

  const table_data = walletHistoryData.map(data => {
    const details = data.attributes.detail;

    return (
      <tr key={data.id} className="">
        <td className="">
          {_.get(data.attributes, 'description') === 'CASH TRANSFER TRANSACTION'
            ? isEmptyChecker(_.get(details, 'reference_number') || 'N/A')
            : _.get(data.attributes, 'description') ===
              'BILLS PAYMENT TRANSACTION'
            ? isEmptyChecker(_.get(details, 'payment_reference') || 'N/A')
            : isEmptyChecker(_.get(details, 'txnid') || 'N/A')}
        </td>
        <td className="">
          {_.get(data.attributes, 'description') === 'CASH TRANSFER TRANSACTION'
            ? isEmptyChecker(_.get(details, 'transferred_at') || 'N/A')
            : isEmptyChecker(_.get(details, 'paid_at') || 'N/A')}
        </td>
        <td className="">
          {_.get(data.attributes, 'description') === 'CASH TRANSFER TRANSACTION'
            ? isEmptyChecker(_.get(details, 'reference_number') || 'N/A')
            : _.get(data.attributes, 'description') ===
              'BILLS PAYMENT TRANSACTION'
            ? isEmptyChecker(_.get(details, 'account_number') || 'N/A')
            : isEmptyChecker(_.get(details, 'refno') || 'N/A')}
        </td>
        <td className="">
          {' '}
          {isEmptyChecker(_.get(details, 'status') || 'N/A')}
        </td>
        <td className="">
          {' '}
          {isEmptyChecker(_.get(data.attributes, 'amount') || 'N/A')}
        </td>
        <td className="">
          {_.get(data.attributes, 'description') === 'BILLS PAYMENT TRANSACTION'
            ? isEmptyChecker(_.get(details, 'biller_code') || 'N/A')
            : isEmptyChecker(_.get(details, 'payment_channel') || 'N/A')}
        </td>
        <td className="">
          {' '}
          {isEmptyChecker(_.get(data.attributes, 'description') || 'N/A')}
        </td>
        <td className="d-flex justify-content-center align-items-center mt-auto">
          <ActionItemButtonGroup
            // wallet transaction id
            walletTransId={data.id}
            walletTransDetails={data.attributes}
            walletDateAt={isEmptyChecker(_.get(details, 'paid_at'))}
            // edit walletTransactionHere later (naming convention)
            walletTransaction={walletTransaction}
            setFormData={setFormData}
            formData={formData}
            mobileNumber={mobileNumber}
            transId={transId}
            onClear={onClear}
          />
        </td>
      </tr>
    );
  });

  return (
    <div className="container-fluid px-2">
      <div className="row mt-4">
        <div className="px-0 col-12 d-none d-md-block">
          <div
            className="overflow-auto"
            style={{ minHeight: '300px', height: '55vh' }}
          >
            <table className="table table-striped table-link table-hover table-light">
              <thead className="">
                <tr>
                  <th className="text-center bg-primary text-white sticky-top">
                    Transaction ID
                  </th>
                  <th className="text-center bg-primary text-white sticky-top">
                    Date Paid
                  </th>
                  <th className="text-center bg-primary text-white sticky-top">
                    Reference Number
                  </th>
                  <th className="text-center bg-primary text-white sticky-top">
                    Status
                  </th>
                  <th className="text-center bg-primary text-white sticky-top">
                    Amount
                  </th>
                  <th className="text-center bg-primary text-white sticky-top">
                    Payment Channel
                  </th>
                  <th className="text-center bg-primary text-white sticky-top">
                    Description
                  </th>
                  <th
                    className="text-center bg-primary text-white sticky-top"
                    style={{ zIndex: '1' }}
                  />
                </tr>
              </thead>
              <tbody>{table_data}</tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

TransactionHistoryTable.propTypes = {
  walletTransaction: PropTypes.instanceOf(Array).isRequired,
  mobileNumber: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  transId: PropTypes.string.isRequired,
  onClear: PropTypes.instanceOf(Function).isRequired,
  // viewWalletLogs: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  findingLogs: api.loading.indexOf(c.VIEW_WALLET_LOGS) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(TransactionHistoryTable);
